<script setup>
import { viewEOIRCaseDetailsPath, viewEOIRCaseFullDetailsPath } from "@/routes"

defineProps({ cases: Array })
</script>

<template>
  <v-container>
    <h1 class="text-headline-large pb-3">
      List of monitored Cases
    </h1>

    <template v-if="cases.length">
      <v-table striped="odd">
        <thead>
          <tr>
            <th class="text-left">
              A#
            </th>
            <th class="text-left">
              Case ID
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in cases"
            :key="item.id"
          >
            <td>
              {{ item.alien_number }}
            </td>
            <td>
              {{ item.eoir_case_id }}
            </td>
            <td class="flex gap-2 justify-end items-center text-right">
              <v-btn
                :href="viewEOIRCaseDetailsPath(item.eoir_case_id)"
                variant="tonal"
              >
                Details
              </v-btn>
              <v-btn
                :href="viewEOIRCaseFullDetailsPath(item.eoir_case_id)"
                variant="tonal"
              >
                Full Details
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-table>
    </template>
    <template v-else>
      <v-card>
        <p>There are no cases being monitored.</p>
        <p>Use the extension to get the EOIR Case Identifier associated with a Party and monitor it.</p>
      </v-card>
    </template>
  </v-container>
</template>
